<template>
  <div>
    <non-ncs-subject-list v-if="mode==='LIST'" :subjects="subjects" @edit="onEdit"/>
    <non-ncs-subject-edit v-if="mode==='EDIT'" :subject="subject"
        @list="onList" @save="onSave" @delete="onDelete" />
  </div>
</template>
<script>
import NonNcsSubjectEdit from './NonNcsSubjectEdit.vue';
import NonNcsSubjectList from './NonNcsSubjectList.vue';
export default {
  name: 'NcsSubjectsStructure',
  components: { NonNcsSubjectList, NonNcsSubjectEdit },
  props: ['subjects'],
  data () {
    return {
      mode: 'LIST',
      subject: undefined
    }
  },
  computed: {
  },
  methods: {
    onEdit (subject) {
      this.subject = subject
      this.mode = 'EDIT'
      // this.$router.push({ query: { ...this.$route.query, mode: 'EDIT' } })
    },
    onList () {
      this.subject = undefined
      this.mode = 'LIST'
      // this.$router.push({ query: { ...this.$route.query, mode: 'LIST' } })
    },
    onSave (subject) {
      const ix = this.subjects.findIndex(s => s._id === subject._id)
      if (ix !== -1) {
        this.subjects.splice(ix, 1, subject)
      } else {
        this.subjects.push(subject)
      }
    },
    onDelete (subject) {
      const ix = this.subjects.findIndex(e => e._id === subject._id)
      if (ix !== -1) {
        this.subjects.splice(ix, 1)
        this.onList()
      }
    }
  }
}
</script>
